module.exports = __webpack_public_path__ + "img/side.8bfbb41e.png";